import { generateClient } from 'aws-amplify/api';
import { listTimeSheets, timeSheetByLocationId } from "../graphql/customQueries";

const client = generateClient();

export default async (locationId, limit = 3, nextToken) => {
    try {
        const {
            data: { timeSheetByLocationId: timesheets },
        } = await client.graphql({
            query: timeSheetByLocationId,
            variables: {
                nextToken,
                locationId,
                limit,
                sortDirection: "DESC",
            },
        });
        return timesheets;
    } catch (ex) {
        console.error("failed to list timesheets", ex);
    }
};
